import React, {useState, useEffect} from 'react'
import Api from '../servicios/api'
import {Header, Titulo, ContenedorHeader} from '../elementos/Header'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import BusquedaFecha from './BusquedaFecha'

const BusquedaVisitas = () => {
    let date = new Date();
    const [datosCargados, setdatosCargados] = useState(false);
    const [visitas, setVisitas] = useState([]);
    const [inputFechaInicio, setInputFechaInicio] = useState(date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + 1).slice(-2));
    const [inputFechaFin, setInputFechaFin] = useState(date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + ultimoDiaMes()).slice(-2));
    const [estadoBusqueda, setEstadoBusqueda] = useState(true);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, [estadoBusqueda]);

    function ultimoDiaMes () {
        let date = new Date();
        let ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return ultimoDia.getDate();
    }

    const cargarDatos = () => {
        if(estadoBusqueda){
            var datosEnviar = {fechaInicio: inputFechaInicio, fechaFin:inputFechaFin}
            fetch(Api+"?consultarVisitas",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                setdatosCargados(true)
                setVisitas(datosRespuesta)
            })
            .catch(console.log)
            setEstadoBusqueda(false)
        }
    }

    const handleChange = (e) => {
        switch(e.target.name){
            case 'fechaInicio':
                setInputFechaInicio(e.target.value);
                break;
            case 'fechaFin':
                setInputFechaFin(e.target.value);
                break;
            default:
                break;
        }
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }

    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Consulta de Visitas</Titulo>
                    </ContenedorHeader>
                </Header>

                <BusquedaFecha
                        inputFechaInicio={inputFechaInicio}
                        inputFechaFin={inputFechaFin}
                        setEstadoBusqueda={setEstadoBusqueda}
                        handleChange={handleChange}
                        busqueda={Api+"ReporteVisitas.php?FechaInicio="+inputFechaInicio+"&FechaFin="+inputFechaFin}
                />
                
                <div className="contenedor-tabla">
                    <div className="card card-tamano card-tamano-fechas">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha Visita</th>
                                        <th>Hora Visita</th>
                                        <th>Institución</th>
                                        <th># de Visitantes</th>
                                        <th>Teléfono</th>
                                        <th>Correo</th>
                                        <th>Opinión</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        visitas.success !== 0 &&
                                            visitas.map(
                                                (visita)=>(
                                                    <tr key={visita.SV_ID}>
                                                        <td>{visita.SV_Fecha}</td>
                                                        <td>{visita.SV_Hora}</td>
                                                        <td>{visita.SV_Institucion}</td>
                                                        <td>{visita.SV_NumVisitantes}</td>
                                                        <td>{visita.SV_Telefono}</td>
                                                        <td>{visita.SV_Correo}</td>
                                                        <td>{visita.GV_Opinion}</td>
                                                    </tr>
                                                )
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>  
            </>
        );
    }
}

export default BusquedaVisitas;